/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/FinancialIndicator', 'model/FinancialIndicatorDataReport', 'model/FinancialIndicatorDataFilter'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('../model/FinancialIndicator'), require('../model/FinancialIndicatorDataReport'), require('../model/FinancialIndicatorDataFilter'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.FinancialIndicatorApi = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.FinancialIndicator, root.ForStractionServiceApi.FinancialIndicatorDataReport, root.ForStractionServiceApi.FinancialIndicatorDataFilter);
  }
}(this, function(ApiClient, FinancialIndicator, FinancialIndicatorDataReport, FinancialIndicatorDataFilter) {
  'use strict';

  /**
   * FinancialIndicator service.
   * @module api/FinancialIndicatorApi
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new FinancialIndicatorApi. 
   * @alias module:api/FinancialIndicatorApi
   * @class
   * @param {module:ApiClient} apiClient Optional API client implementation to use,
   * default to {@link module:ApiClient#instance} if unspecified.
   */
  var exports = function(apiClient) {
    this.apiClient = apiClient || ApiClient.instance;


    /**
     * Callback function to receive the result of the financialIndicatorLoadAllGet operation.
     * @callback module:api/FinancialIndicatorApi~financialIndicatorLoadAllGetCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FinancialIndicator>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * loadAll
     * @param {String} _4SAPIAppID 
     * @param {module:api/FinancialIndicatorApi~financialIndicatorLoadAllGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FinancialIndicator>}
     */
    this.financialIndicatorLoadAllGet = function(_4SAPIAppID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling financialIndicatorLoadAllGet";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [FinancialIndicator];

      return this.apiClient.callApi(
        '/FinancialIndicator/loadAll', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the financialIndicatorLoadGet operation.
     * @callback module:api/FinancialIndicatorApi~financialIndicatorLoadGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/FinancialIndicator} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * load
     * @param {String} _4SAPIAppID 
     * @param {Integer} indicatorID 
     * @param {module:api/FinancialIndicatorApi~financialIndicatorLoadGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/FinancialIndicator}
     */
    this.financialIndicatorLoadGet = function(_4SAPIAppID, indicatorID, callback) {
      var postBody = null;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling financialIndicatorLoadGet";
      }

      // verify the required parameter 'indicatorID' is set
      if (indicatorID == undefined || indicatorID == null) {
        throw "Missing the required parameter 'indicatorID' when calling financialIndicatorLoadGet";
      }


      var pathParams = {
      };
      var queryParams = {
        'indicatorID': indicatorID
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = FinancialIndicator;

      return this.apiClient.callApi(
        '/FinancialIndicator/load', 'GET',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }

    /**
     * Callback function to receive the result of the financialIndicatorSearchDataReportPut operation.
     * @callback module:api/FinancialIndicatorApi~financialIndicatorSearchDataReportPutCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/FinancialIndicatorDataReport>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * searchDataReport
     * @param {String} _4SAPIAppID 
     * @param {Array.<module:model/FinancialIndicatorDataFilter>} body 
     * @param {module:api/FinancialIndicatorApi~financialIndicatorSearchDataReportPutCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/FinancialIndicatorDataReport>}
     */
    this.financialIndicatorSearchDataReportPut = function(_4SAPIAppID, body, callback) {
      var postBody = body;

      // verify the required parameter '_4SAPIAppID' is set
      if (_4SAPIAppID == undefined || _4SAPIAppID == null) {
        throw "Missing the required parameter '_4SAPIAppID' when calling financialIndicatorSearchDataReportPut";
      }

      // verify the required parameter 'body' is set
      if (body == undefined || body == null) {
        throw "Missing the required parameter 'body' when calling financialIndicatorSearchDataReportPut";
      }


      var pathParams = {
      };
      var queryParams = {
      };
      var headerParams = {
        '4S-API-App-ID': _4SAPIAppID
      };
      var formParams = {
      };

      var authNames = [];
      var contentTypes = [];
      var accepts = ['application/json'];
      var returnType = [FinancialIndicatorDataReport];

      return this.apiClient.callApi(
        '/FinancialIndicator/searchDataReport', 'PUT',
        pathParams, queryParams, headerParams, formParams, postBody,
        authNames, contentTypes, accepts, returnType, callback
      );
    }
  };

  return exports;
}));
